/* The hero's source tabs — the bar's box only; the tab itself is `shared/ui/TabStrip`'s. The bar
 * takes its height from the hero, which is `flex: 1`, so the similar strip under the hero stays
 * where it was. */

.bar {
  gap: var(--space-6);
  margin-bottom: var(--space-3);
  border-bottom: var(--border-hairline) solid var(--border);
}

.label {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  max-width: 240px;
}

.thumb {
  display: block;
  flex: none;
  width: 40px;
  height: 23px;
  object-fit: cover;
  background: var(--bg-sunken);
  border-radius: var(--radius-4px);
}

.mark {
  display: grid;
  flex: none;
  place-items: center;
  width: 16px;
  height: 16px;
  background: var(--plate-on-photo);
  border-radius: var(--radius-4px);
}

.markGlyph {
  display: block;
  width: 11px;
  height: 11px;
}

.word {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
